module.exports = __webpack_public_path__ + "media/src/shared_components/images/chat_bubble_icon-ba39b078320eb0a44373716a4b97c56d.svg";